import React from 'react'

// material ui
import Hidden from '@mui/material/Hidden'

// components
import CamperStatus from 'components/account/CamperStatus'
import SectionItem from 'components/atoms/SectionItem'
import PersonCard from 'components/shared/PersonCard'
import AddDaysButton from './AddDaysButton'
import DesktopPlanList from './DesktopPlanList'
import MobilePlanList from './MobilePlanList'
import ReservationDays from './ReservationDays'

const CamperPlans = props => {
  const {
    account,
    camper,
    reupRequired,
    editable,
    enableCovidRequirements,
    season
  } = props
  const { plans, camperSessions } = camper
  const { registrationStatus } = account

  return (
    <SectionItem>
      <PersonCard
        header={
          <CamperStatus
            camper={camper}
            reupRequired={reupRequired}
            account={account}
          />
        }
        desktopButtons={
          editable && registrationStatus.registered ? (
            <AddDaysButton align='right' />
          ) : null
        }
        mobileButtons={
          editable && registrationStatus.registered ? <AddDaysButton /> : null
        }
      >
        {plans && plans.length > 0 && (
          <>
            <Hidden mdDown>
              <DesktopPlanList
                plans={plans}
                enableCovidRequirements={enableCovidRequirements}
              />
            </Hidden>

            <Hidden mdUp>
              <MobilePlanList
                plans={plans}
                enableCovidRequirements={enableCovidRequirements}
              />
            </Hidden>
          </>
        )}

        <ReservationDays camperSessions={camperSessions} />
      </PersonCard>
    </SectionItem>
  )
}

export default CamperPlans
